import DiffMatchPatch from "diff-match-patch";

const dmp = new DiffMatchPatch();

export const merge3 = (base = "", ours = "", theirs = "") => {
  if (ours === base || ours === theirs) return theirs;
  if (theirs === base) return ours;
  return dmp.patch_apply(dmp.patch_make(base, ours), theirs)[0];
};

export const mergeAttrs = (base = {}, ours = {}, theirs = {}) => {
  const out = { ...theirs };
  new Set([...Object.keys(base), ...Object.keys(ours)]).forEach((k) => {
    if ((ours[k] ?? "") === (base[k] ?? "")) return;
    if (ours[k] === undefined || ours[k] === "") delete out[k];
    else out[k] = ours[k];
  });
  return out;
};

const key = (k) => `lr-draft:${k}`;
export const draft = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(key(k))); } catch { return null; } },
  set: (k, v) => { try { localStorage.setItem(key(k), JSON.stringify({ ...v, ts: Date.now() })); } catch { /* storage full */ } },
  clear: (k) => { try { localStorage.removeItem(key(k)); } catch { /* ignore */ } },
};
